// extracted by mini-css-extract-plugin
export var filterIncDec = "_d8-0";
export var leftBorder = "_d8-1";
export var rightBorder = "_d8-2";
export var stringInput = "_d8-3";